
import { Category, ItemProps } from "@/types/ApiTypes";
import CategoryDND from "./Category.dnd";
import { useTranslation } from "react-i18next";




export default function MenuCards({ items }: ItemProps) {
  const { t } = useTranslation();


    return (
        <>


            {items ? items.map((item: Category) => {
                return <CategoryDND id={item.categoryID} title={t(item.nameEN, item.nameAR) as string} key={item.categoryID} />;
            }) : null}


        </>
    )
}
